import { query, collection, orderBy, firestore, doc, where } from '~providers/firebase'

const listClasses = (userId: string) =>
  query(
    collection(firestore, 'classes'),
    where('members', 'array-contains', userId),
    orderBy('name', 'asc'),
  )

const listClassesTeacher = (userId: string) =>
  query(
    collection(firestore, 'classes'),
    where('teachers', 'array-contains', userId),
    orderBy('name', 'asc'),
  )

const listChats = (classId: string) =>
  query(collection(firestore, 'classes', classId, 'chats'), orderBy('updated_at', 'desc'))

const listReplies = (userId: string, classId: string) =>
  query(
    collection(firestore, 'users', userId, 'chats'),
    where('parent_class_id', '==', classId),
    orderBy('updated_at', 'desc'),
  )

const getClass = (classId: string) => doc(firestore, 'classes', classId)

export default {
  listClasses,
  listClassesTeacher,
  listChats,
  listReplies,
  getClass,
}
